import { Component, inject, OnInit } from '@angular/core'
import Order from '@account/Order'
import { ActivatedRoute, ParamMap } from '@angular/router'
import { switchMap } from 'rxjs/operators'
import HttpError from '@ui/HttpError'
import { OrderService } from '@account/Services/OrderService'
import { PageComponent } from '@account/Components/ui/Page/Page.Component'

import { CardComponent } from '@ui/Components/Card/Card.Component'
import { CardTitleComponent } from '@ui/Components/Card/CardTitle.Component'
import { CardContentComponent } from '@ui/Components/Card/CardContent.Component'
import { OrderItemsComponent } from '@account/Components/Orders/Order/OrderItems.Component'
import { OrderPaymentsComponent } from '@account/Components/Orders/Order/OrderPayments.Component'

@Component({
	selector: 'order-component',
	templateUrl: './Order.Component.html',
	imports: [
		PageComponent,
		CardComponent,
		CardTitleComponent,
		CardContentComponent,
		OrderItemsComponent,
		OrderPaymentsComponent,
	],
})
export class OrderComponent implements OnInit {
	public order: Order

	private readonly ordersService: OrderService

	private readonly route: ActivatedRoute

	constructor() {
		this.ordersService = inject(OrderService)
		this.route = inject(ActivatedRoute)
	}

	public ngOnInit() {
		this.route.paramMap
			.pipe(
				switchMap(async (params: ParamMap) => {
					try {
						return await this.ordersService.find(parseInt(params.get('id'), 10))
					} catch (error) {
						if (!(error instanceof HttpError)) {
							throw error
						}
					}
				}),
			)
			.subscribe((currentOrder: Order) => {
				if (currentOrder instanceof Order) {
					this.order = currentOrder
				}
			})
	}
}
